import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../app/commonReducer';
import { withComponentId } from './ComponentIdContext';
import { withComponentName } from './ComponentNameContext';
import { TYPE_DISABLE } from './sync-component/Const';
import { syncComponentSelector } from '../helpers/Common';
import EventEmitter, { SYNC_COMPONENT_SEARCH } from '../helpers/EventEmitter';

class RowClick extends PureComponent {
  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE || !listOrganizationByOrganCode[organCode]) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const { children } = this.props;
    return children(this.onRowClick);
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  syncType: syncComponentSelector(state, componentName, componentId),
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
});

RowClick.propTypes = {};

export default compose(
  withComponentId,
  withComponentName,
  connect(mapStateToProps),
)(RowClick);
